export default __webpack_public_path__ + "static/media/dappradarLOGO.3a40c851.png";